module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrows-move-71fe0c1f.svg";